import withholdingPayment from './withholding-payment.vue'
export default withholdingPayment
